import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { SdsIcon } from '@nieuwestroom/sds-icon';

import { OnboardingStepperStep } from '../../model';

@Component({
  selector: 'nscp-onboarding-stepper',
  imports: [TranslocoDirective, SdsIcon],
  styleUrl: './nscp-onboarding-stepper.scss',
  templateUrl: './nscp-onboarding-stepper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'nscp-onboarding-stepper',
  },
})
export class NscpOnboardingStepper {
  public readonly steps = input.required<readonly OnboardingStepperStep[]>();
  public readonly currentIndex = input.required<number>();

  protected readonly currentStepNumber = computed(() => this.currentIndex() + 1);
  protected readonly totalSteps = computed(() => this.steps().length);
}
